import React from "react";
import styled from "styled-components";
import { ScrollLink } from "react-scroll";
import Headline from "../components/Headline";
import SubHeadline from "../components/SubHeadline";
import Strong from "../components/Strong";
import Button from "../components/Button";
import colors from "../config/colors";
import media from "../config/mediaQueries";

const IntroWrap = styled.section`
  width: 100%;
  min-height: 100vh;
  background: ${colors.yellow};
  background: linear-gradient(
    135deg,
    ${colors.yellow} 0%,
    ${colors.yellow} 60%,
    #d6c639 60%,
    #d6c639 75%,
    #535034 75%,
    #535034 78%,
    #333 78%,
    #333 100%
  );
  padding: 10rem 2rem;
  transition: all 200ms linear;
  ${media.desktop`
    --grad-1: 60%;
    --grad-2: 75%;
    --grad-3: 78%;
    padding: 10rem 4rem;
    background: linear-gradient(
      135deg,
      ${colors.yellow} 0%,
      ${colors.yellow} var(--grad-1),
      #d6c639 var(--grad-1),
      #d6c639 var(--grad-2),
      #535034 var(--grad-2),
      #535034 var(--grad-3),
      #333 var(--grad-3),
      #333 100%
    );
  `};
`;

const ScrollButton = ScrollLink(Button);

const IntroButton = styled.div`
  margin-top: 2rem;
`;

export default props => (
  <IntroWrap {...props}>
    <Headline responsive>
      <Strong>Servus, Gude</Strong> und <Strong>Hallo!</Strong>
    </Headline>
    <SubHeadline responsive>
      Ich bin <Strong upper>Tom Raithel</Strong>,<br />
      Software Engineer und Architect aus <Strong upper>Wiesbaden.</Strong>
    </SubHeadline>
    <IntroButton>
      <ScrollButton to="about" smooth={true} offset={-50} href="#about">
        mehr erfahren ↓
      </ScrollButton>
    </IntroButton>
  </IntroWrap>
);



// WEBPACK FOOTER //
// ./src/components/Intro.js